
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/merchants",
      function () {
        return require("private-next-pages/merchants/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/merchants"])
      });
    }
  